import React from 'react';
import { ProcessingStatus } from 'records/ProcessingStatus';
import UploadsListRow from './UploadsListRow';

type Props = {
  style: React.CSSProperties;
  index: number;
  data: ProcessingStatus[];
};

const UploadsRenderer: React.FC<Props> = ({ style, data, index }) => {
  const upload = data[index];

  return upload ? (
    <UploadsListRow processingStatus={upload} style={style} />
  ) : null;
};

export { UploadsRenderer };
